export default function Loading({ label = "Loading..." }: { label?: string }) {
  return (
    <div className="empty" role="status">
      {label}
    </div>
  );
}
